export const BaseUrl = process.env.REACT_APP_API_URL || "https://api-eventprix.azurewebsites.net/api/";
export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || "https://eventprix.com/";


const APIS = { 
  LOGIN: "Admin/authenticate",
  GOOGLE_LOGIN: "Admin/authenticate-with-google",
  REFRESH_TOKEN: BaseUrl + "Admin/refresh-token",
  ADD_USER: BaseUrl + "User",
  UPDATE_USER: BaseUrl + "User",
  FORGOT_PASSWORD: BaseUrl + "Admin/forgotPassword",
  CHANGE_USER_PASSWORD: BaseUrl + "Admin/change-user-password",
  GET_USER_BY_ID: BaseUrl + "User",
  GET_ALL_USER: BaseUrl + "User/users",
  EMAIL: BaseUrl + "User/SubscribeEmail",
  CONTACT_US: BaseUrl + "ContactUs",
  RESET_PASSWORD: BaseUrl + "Admin/reset-password",
  VALIDATE_PASSWORD: BaseUrl + "Admin/validate-password",
  GET_ALL_EVENT_CATEGORIES: "EventCategories",
  GET_ORDER_ID_BY_TICKET: "Order",
  GET_ALL_TICKET_TYPE: "Event/ticket-type",
  GET_ALL_TIME_ZONE: "Event/time-zone",
  GET_EVENT_BY_ID: BaseUrl + "Event",
  GET_BY_ID_EVENT: BaseUrl + "Event",
  DELETE_CONFIG: BaseUrl + "Event/TicketConfig",
  GET_ALL_EVENT_VENUE: BaseUrl + "Event/event-venue",
  GET_ALL_EVENT_SCHEDULE: BaseUrl + "Event/event-schedule",
  GET_ALL_EVENT_TICKET_CONFIG: BaseUrl + "Event/ticket-config-by-eventId",
  GET_ALL_EVENT_FAQ: BaseUrl + "Event/faq-by-event-id",
  PUBLISH_EVENT: BaseUrl + "Event/publish-event",
  GET_EVENT_DETAIL: BaseUrl + "Event/search",
  GET_EVENT_DETAIL_HOME_PAGE: BaseUrl + "Event/home-page",
  GET_COUPON_BY_ID: BaseUrl + "Coupon/",
  GET_EVENT_DETIAL_ADMIN: BaseUrl + "Event/admin/event",

  //Event Detail
  ADD_EVENT_DETAIL: "Event/event-detail/add",
  Add_Event_Venue: "Event/venue/add",
  Add_Event_TICKET_CONFIG: "Event/event-ticket-config/add",
  ADD_EVENT_SCHEDULE: "Event/event-schedule/add",
  ADD_EVENT_FAQ: "Event/event-faq/add",
  EVENT_PUBLISH_SCHEDULE: "Event/publish-schedule-event",
  DELETE_EVENT: BaseUrl + "Event",
  EVENT_ROUTING: BaseUrl + "Event/event-routing",

  //Coupon
  GET_ALL_COUPON: BaseUrl + "Coupon/search",
  ADD_COUPON_DETAIL: "Coupon",
  UPDATE_COUPON: BaseUrl + "Coupon",
  DELETE_COUPON: BaseUrl + "Coupon",

  CREATE_INTENT: BaseUrl + "Payment/create-intent",
  GET_USER_IP: "https://api.ipify.org/?format=jsonp&callback=JSONP_CALLBACK",
  GET_CITY_BY_IP: "https://ipinfo.io/",
  CHECKOUT: BaseUrl + "payment",
  GET_ALL_STATE: "countryAndCity/all-state",

  // get all city and country
  GET_ALL_CITY: BaseUrl + "countryAndCity/all-city",
  GET_ALL_COUNTRY: BaseUrl + "countryAndCity/all-country",

  // calculate total amount
  CHARGE_CALCULATION: BaseUrl + "payment/charge-calculation",
  RETRIEVE_PAYMENT: BaseUrl + "payment/retrieve-payment",

  // get all event
  GET_ALL_EVENTS: BaseUrl + "event/event-detail-all",

  // order
  ORDER_WITH_TICKET: BaseUrl + "order/search",
  TICKET_BY_ID: BaseUrl + "ticket/ticket-by-id",
  TICKET_CHECK_IN: BaseUrl + "ticket/check-in",
  ALL_PAYMENT_STATUS: BaseUrl + "order/all-payment-status",
  PAYMENT_STATUS_UPDATE: BaseUrl + "order/payment-status-update",
  SEND_ORDER_CONFORMATION_EMAIL:
    BaseUrl + "order/send-order-confirmation-email",
  SEND_EMAIL: BaseUrl + "order/send-email",

  SALES_REPORT: BaseUrl + "salesReport",

  //csv export
  DOWNLOAD_CSV: BaseUrl + "csvExport",

  // download ticket pdf
  DOWNLOAD_TICKET_PDF: BaseUrl + "ticket/download-ticket",

  //dashboard
  GET_DASHBOARD_DATA: BaseUrl + "dashboard",
  SALES_CONSOLIDATED_REPORT: BaseUrl + "dashboard/sales-consolidated-report",
  GET_LAT_LONG_TO_LOCATION: "https://maps.googleapis.com/maps/api/timezone/json?location",

  // STRIPE_SUCCESS_PAYMENT_REDIRECT_URL : "https://43.251.72.201/checkout-successful",
  // STRIPE_SUCCESS_PAYMENT_REDIRECT_URL : "http://localhost:3000/checkout-successful",

  STRIPE_SUCCESS_PAYMENT_REDIRECT_URL: WEBSITE_URL +"checkout-successful",

  IP_INFO_TOKEN: "?token=1f8e916c7746d9",

  // Service Fee Settings
  GET_SERVICE_FEE: BaseUrl + "admin/service-fee",
  GET_ALL_SERVICE_FEES: BaseUrl + "admin/service-fee/all",
  UPDATE_SERVICE_FEE: BaseUrl + "admin/service-fee",
};

export default APIS;
